const pageNameKey = "sourcesInfoWithPopover";

export const sourcesInfoWithPopoverEn = {
  [pageNameKey]: {
    sourceInfoTitle: "Source Info",
    sourceId: "Source ID",
    copiedToClipboardSnackBarMessage: "copied to clipboard!",
    nodeSnackBarError: "Error copying to clipboard.",
    tooltipText: "View source information",
  },
};

export const sourcesInfoWithPopoverPtBr = {
  [pageNameKey]: {
    sourceInfoTitle: "Informações da fonte",
    sourceId: "ID da fonte",
    copiedToClipboardSnackBarMessage: "Copiado para a área de transferência!",
    nodeSnackBarError: "Erro ao copiar para a área de transferência.",
    tooltipText: "Ver informações da fonte",
  },
};

export const sourcesInfoWithPopoverDe = {
  [pageNameKey]: {
    sourceInfoTitle: "Quelleninfo",
    sourceId: "Quellen-ID",
    copiedToClipboardSnackBarMessage: "in die Zwischenablage kopiert!",
    nodeSnackBarError: "Fehler beim Kopieren in die Zwischenablage.",
    tooltipText: "Quelleninformationen anzeigen",
  },
};

export const sourcesInfoWithPopoverZhHans = {
  [pageNameKey]: {
    sourceInfoTitle: "源信息",
    sourceId: "来源ID",
    copiedToClipboardSnackBarMessage: "已复制到剪贴板！",
    nodeSnackBarError: "复制到剪贴板时出错。",
    tooltipText: "查看源信息",
  },
};

export const sourcesInfoWithPopoverIt = {
  [pageNameKey]: {
    sourceInfoTitle: "Info macchina",
    sourceId: "ID macchina",
    copiedToClipboardSnackBarMessage: "copiata negli appunti!",
    nodeSnackBarError: "Errore durante la copia negli appunti.",
    tooltipText: "Visualizza informazioni macchina",
  },
};

export const sourcesInfoWithPopoverEs = {
  [pageNameKey]: {
    sourceInfoTitle: "Información de origen",
    sourceId: "Origen ID",
    copiedToClipboardSnackBarMessage: "¡Copiado al portapapeles!",
    nodeSnackBarError: "Error al copiar al portapapeles.",
    tooltipText: "Ver la información de origen",
  },
};

export const sourcesInfoWithPopoverNl = {
  [pageNameKey]: {
    copiedToClipboardSnackBarMessage: "gekopieerd naar klembord!",
    nodeSnackBarError: "Fout bij kopiëren naar klembord.",
    sourceId: "Bron-ID",
    sourceInfoTitle: "Bron-informatie",
    tooltipText: "Bron-informatie weergeven",
  },
};

export const sourcesInfoWithPopoverTr = {
  [pageNameKey]: {
    copiedToClipboardSnackBarMessage: "panoya kopyalandı!",
    nodeSnackBarError: "Panoya kopyalanırken hata oluştu.",
    sourceId: "Kaynak kimliği",
    sourceInfoTitle: "Kaynak Bilgisi",
    tooltipText: "Kaynak bilgilerini görüntüle",
  },
};
